window.SEARCH_DICT = {
  "canon": [
  "10mm",
  "3i",
  "abutment",
  "abutments",
  "accessories",
  "actival",
  "active",
  "adin",
  "adin2",
  "alpha",
  "amelo",
  "analog",
  "analogs",
  "anatomic",
  "anatomical",
  "angle",
  "angled",
  "ankylos",
  "anonym",
  "anthofit",
  "anthogyr",
  "anyone",
  "anyridge",
  "astra",
  "axiom",
  "ball",
  "base",
  "bases",
  "bego",
  "biohorizons",
  "biolevel",
  "biomet",
  "bionika",
  "bioplant",
  "biopoz",
  "bioss",
  "biotech",
  "biotop",
  "bite",
  "blank",
  "blue",
  "blx",
  "bodies",
  "bone",
  "bonelevel",
  "bonelit",
  "brand",
  "branemark",
  "bredent",
  "bridges",
  "brown",
  "builder",
  "cad",
  "calibrating",
  "callus",
  "cam",
  "camlog",
  "castable",
  "ccl",
  "cement",
  "classic",
  "closed",
  "closefit",
  "compact",
  "compatible",
  "cone",
  "conefit",
  "conelog",
  "conical",
  "copasky",
  "coping",
  "copings",
  "core",
  "cortex",
  "cortical",
  "corticon",
  "cortilog",
  "cosmodent",
  "cover",
  "crosshead",
  "crowns",
  "current",
  "cylindrical",
  "dcl",
  "default",
  "delta",
  "dental",
  "denti",
  "dentis",
  "dentium",
  "dentum",
  "diameter",
  "digital",
  "dio",
  "direct",
  "discount",
  "drill",
  "driver",
  "drivers",
  "easy",
  "ecoline",
  "ecoplant",
  "egyedigen",
  "elements",
  "external",
  "fairtwo",
  "flat",
  "flexi",
  "fluted",
  "form",
  "friadent",
  "frialit",
  "fullplant",
  "geometry",
  "gray",
  "green",
  "head",
  "heads",
  "healing",
  "hexacone",
  "hexagonal",
  "hicon",
  "hybrid",
  "hybridmini",
  "icx",
  "ihde",
  "implant",
  "implants",
  "implie",
  "impression",
  "insert",
  "instrument",
  "instruments",
  "integroot",
  "interactive",
  "interface",
  "internal",
  "intralock",
  "isy",
  "kontact",
  "lamellar",
  "large",
  "lasak",
  "legacy",
  "length",
  "level",
  "line",
  "locator",
  "long",
  "manual",
  "material",
  "mdi",
  "mechanical",
  "medentika",
  "medical",
  "megagen",
  "member",
  "members",
  "membrane",
  "mesh",
  "metal",
  "micro",
  "mindenhova",
  "mini",
  "mis",
  "multi",
  "multiunit",
  "muszerek",
  "nanoplant",
  "narrow",
  "neodent",
  "neoss",
  "nice",
  "nobel",
  "normal",
  "number",
  "oblique",
  "octa",
  "offer",
  "offers",
  "open",
  "oralplant",
  "osseospeed",
  "osstem",
  "osteotomy",
  "other",
  "package",
  "parallel",
  "patent",
  "pcl",
  "perforated",
  "periotype",
  "pitch",
  "pitt",
  "plastic",
  "plate",
  "platform",
  "positioned",
  "positioning",
  "premilled",
  "primer",
  "prosthetic",
  "protetim",
  "purple",
  "regeneration",
  "registry",
  "regsitration",
  "related",
  "removable",
  "replace",
  "replant",
  "restoration",
  "retained",
  "revois",
  "ring",
  "root",
  "sanatmetal",
  "scan",
  "scanbody",
  "scandrea",
  "screw",
  "screwable",
  "screwdriver",
  "screwdrivers",
  "screwed",
  "screws",
  "select",
  "semados",
  "seven",
  "sgs",
  "short",
  "sic",
  "size",
  "sky",
  "slim",
  "sm",
  "small",
  "special",
  "speedy",
  "sr",
  "stabile",
  "standard",
  "stepped",
  "straight",
  "straumann",
  "sulcus",
  "superline",
  "surgical",
  "symplant",
  "system",
  "tapered",
  "tech",
  "technical",
  "templant",
  "temporary",
  "test",
  "thickness",
  "thommen",
  "thread",
  "through",
  "tiolox",
  "titan",
  "titanium",
  "title",
  "toothwork",
  "transplantation",
  "trapezoidal",
  "travel",
  "tray",
  "tubular",
  "type",
  "uf",
  "ujtermektorzs",
  "uniform",
  "uniplant",
  "unit",
  "universal",
  "unknown",
  "vanmembere",
  "vantage",
  "vent",
  "vinci",
  "vital",
  "white",
  "wide",
  "width",
  "wieland",
  "with",
  "xive",
  "yellow",
  "zigoma",
  "zimmer",
  "zircon",
  "zygomat"
],
  "disp": {},
  "syn": {
  "abutmen": "abutment",
  "abutmet": "abutment",
  "abutement": "abutment",
  "abbutment": "abutment",
  "implnt": "implant",
  "imlant": "implant",
  "implat": "implant",
  "inplant": "implant",
  "locater": "locator",
  "lokator": "locator",
  "loactor": "locator",
  "healling": "healing",
  "heeling": "healing",
  "impresion": "impression",
  "imression": "impression",
  "temporarry": "temporary",
  "temprorary": "temporary",
  "castble": "castable",
  "casteable": "castable",
  "zirkon": "zircon",
  "zirconia": "zircon",
  "cirkon": "zircon",
  "titanum": "titanium",
  "titanim": "titanium",
  "titan": "titanium",
  "scanbod": "scanbody",
  "scan-body": "scanbody",
  "multiunit": "multi-unit",
  "multi unit": "multi-unit",
  "multicompact": "multi-compact",
  "multi compact": "multi-compact",
  "srew": "screw",
  "scew": "screw",
  "screww": "screw",
  "anolog": "analog",
  "analogue": "analog",
  "straumman": "straumann",
  "straumn": "straumann",
  "staumann": "straumann",
  "noble": "nobel",
  "nobl": "nobel",
  "branemar": "branemark",
  "branmark": "branemark",
  "asztra": "astra",
  "kontackt": "kontact",
  "kontak": "kontact",
  "neondent": "neodent",
  "megagn": "megagen",
  "ankilos": "ankylos",
  "kamlog": "camlog"
},
  "links": {
  "abutment": "/collections/abutments_auto",
  "abutments": "/collections/abutments_auto",
  "ball": "/collections/ball-head-abutments",
  "ballhead": "/collections/ball-head-abutments",
  "ball head": "/collections/ball-head-abutments",
  "locator": "/collections/locator-abutments",
  "locators": "/collections/locator-abutments",
  "tube": "/collections/tube-abutment",
  "anatomical": "/collections/anatomical-abutments",
  "delta": "/collections/delta-abutments",
  "trapezoidal": "/collections/trapezoidal-abutments",
  "universal": "/collections/universal-abutments",
  "narrow": "/collections/narrow-abutments",
  "temporary": "/collections/temporary-abutments",
  "castable": "/collections/castable-abutments",
  "impression": "/collections/impression-copings",
  "coping": "/collections/impression-copings",
  "copings": "/collections/impression-copings",
  "healing": "/collections/healing-abutments",
  "scanbody": "/collections/scan-bodies",
  "scan body": "/collections/scan-bodies",
  "scanbodies": "/collections/scan-bodies",
  "multi-unit": "/collections/multi-unit-abutments",
  "multiunit": "/collections/multi-unit-abutments",
  "multi-compact": "/collections/multi-compact-abutments",
  "multicompact": "/collections/multi-compact-abutments",
  "screw": "/collections/screws",
  "screws": "/collections/screws",
  "implant": "/collections/implants",
  "implants": "/collections/implants",
  "analog": "/collections/implant-analogs",
  "analogs": "/collections/implant-analogs",
  "zircon": "/collections/zircon-crowns-bridges",
  "crown": "/collections/zircon-crowns-bridges",
  "bridge": "/collections/zircon-crowns-bridges",
  "framework": "/collections/cad-cam-bridge",
  "frameworks": "/collections/cad-cam-bridge",
  "titanium base": "/collections/titanium-bases",
  "base": "/collections/titanium-bases",
  "bases": "/collections/titanium-bases",
  "interface": "/collections/interfaces",
  "interfaces": "/collections/interfaces",
  "membrane": "/collections/titanium-mesh",
  "mesh": "/collections/titanium-mesh",
  "bone": "/collections/bone-regeneration",
  "graft": "/collections/bone-regeneration",
  "instrument": "/collections/dental-implantation-instruments",
  "instruments": "/collections/dental-implantation-instruments",
  "drill": "/collections/dental-implantation-instruments",
  "driver": "/collections/dental-implantation-instruments",
  "screwdriver": "/collections/dental-implantation-instruments",
  "wrench": "/collections/dental-implantation-instruments",
  "cad cam": "/collections/cad-cam",
  "cadcam": "/collections/cad-cam"
},
  "brand": {
  "straumann bonelevel": "/collections/straumann-bonelevel-bl",
  "bonelevel": "/collections/straumann-bonelevel-bl",
  "straumann sin octa": "/collections/bionika-st",
  "nobel branemark": "/collections/bionika-br",
  "branemark": "/collections/bionika-br",
  "nobel replace select": "/collections/bionika-rp",
  "nobel replace": "/collections/bionika-rp",
  "nobel active": "/collections/bionika-actival",
  "nobel parallel cc": "/collections/bionika-actival",
  "nobel parallel": "/collections/bionika-actival",
  "astra tech osseospeed tx": "/collections/bionika-as",
  "astra tech osseospeed ev": "/collections/bionika-ae",
  "astra": "/collections/bionika-as",
  "kontact": "/collections/bionika-kt",
  "neodent gm": "/collections/bionika-nd",
  "neodent": "/collections/bionika-nd",
  "megagen anyridge": "/collections/bionika-mg",
  "megagen anyone": "/collections/bionika-mo",
  "megagen": "/collections/bionika-mg",
  "ankylos c": "/collections/ankylos-c-ca",
  "ankylos x": "/collections/bionika-cx",
  "ankylos": "/collections/ankylos-c-ca",
  "camlog": "/collections/cortilog-pcl",
  "conelog": "/collections/cortilog-ccl",
  "isy": "/collections/bionika-isy",
  "dentium superline": "/collections/bionika-dentum",
  "dentium nr line": "/collections/bionika-dn",
  "dentium": "/collections/bionika-dentum",
  "bredent sky": "/collections/bionika-bb",
  "bredent copasky": "/collections/bionika-bk",
  "bredent": "/collections/bionika-bb",
  "biohorizons": "/collections/bionika-bh",
  "biomet 3i": "/collections/bionika-3i",
  "biomet": "/collections/bionika-3i",
  "tiolox": "/collections/bionika-tlx",
  "uniplant": "/collections/bionika-up",
  "thommen": "/collections/bionika-th",
  "neoss": "/collections/bionika-no",
  "anthogyr axiom": "/collections/bionika-ag",
  "anthogyr anthofit": "/collections/bionika-at",
  "anthogyr": "/collections/bionika-ag",
  "fullplant": "/collections/bionika-fp",
  "bego semados": "/collections/bionika-sd",
  "bego": "/collections/bionika-sd",
  "sic ace max": "/collections/bionika-si",
  "sic vantage": "/collections/bionika-sv",
  "sic": "/collections/bionika-si",
  "dio sm": "/collections/bionika-di-sm",
  "dio uf": "/collections/bionika-di-uf",
  "dio": "/collections/bionika-di-sm",
  "osstem": "/collections/bionika-corticon",
  "amelo": "/collections/bionika-bioplant",
  "symplant": "/collections/bionika-bioplant",
  "pitt easy": "/collections/bionika-bioplant",
  "ot medical": "/collections/bionika-bioplant",
  "sgs": "/collections/bionika-biolevel",
  "dentis": "/collections/bionika-biolevel",
  "mis seven": "/collections/bionika-biolevel",
  "alpha bio ih": "/collections/bionika-biolevel",
  "adin standard": "/collections/bionika-biolevel",
  "cortex": "/collections/bionika-biolevel",
  "zimmer": "/collections/bionika-biolevel",
  "tri vent": "/collections/bionika-biolevel",
  "alpha bio cs": "/collections/bionika-implie",
  "alpha bio nice": "/collections/bionika-implie",
  "adin closefit": "/collections/bionika-actival",
  "icx da vinci": "/collections/bionika-bonelit",
  "icx templant": "/collections/bionika-hicon",
  "denti root form": "/collections/bionika-bioss",
  "scandrea": "/collections/bionika-scandrea",
  "hicon": "/collections/bionika-hicon",
  "cortilog pcl": "/collections/cortilog-pcl",
  "cortilog ccl": "/collections/cortilog-ccl",
  "mdi": "/collections/bionika-mdi"
}
};

/* ==== BNK: globális helyesírás-javító =======================================
   A keresőszavak elgépelését javítja a fenti szótár alapján:
     1. `syn` — kézi elírás→helyes térkép (leggyakoribb hibák),
     2. `canon` — a katalógus szavai; Levenshtein-távolsággal a legközelebbi
        szóra javítunk (4-5 betűs szónál 1, 6+ betűsnél 2 eltérésig).
   A találatot MINDEN keresőfelület használja: a fejléc prediktív keresője
   (predictive-search.js) és a keresőoldali mentőháló (semantic-search.js).
   Visszatérés: a javított kifejezés, vagy null, ha nincs mit javítani.
   ========================================================================== */
(function () {
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function lev(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    if (!m) return n;
    if (!n) return m;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 0; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        var c = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
      }
    }
    return d[m][n];
  }
  window.BnkSpellFix = function (q) {
    try {
      var D = window.SEARCH_DICT || {};
      var qn = norm(q);
      if (!qn) return null;
      var canon = D.canon || [], syn = D.syn || {}, links = D.links || {}, brand = D.brand || {};
      var changed = false;
      var out = qn.split(' ').map(function (t) {
        if (!t) return t;
        if (syn[t]) { changed = true; return syn[t]; }
        // ismert szó (katalógus/kategória/márka) → nem nyúlunk hozzá
        if (t.length < 4 || links[t] || brand[t] || canon.indexOf(t) !== -1) return t;
        var best = null, bd = 99;
        for (var i = 0; i < canon.length; i++) {
          var c = canon[i];
          if (c.indexOf(' ') !== -1) continue;          // csak egyszavas jelöltek
          if (Math.abs(c.length - t.length) > 2) continue;
          var dd = lev(t, c);
          if (dd < bd) { bd = dd; best = c; }
        }
        var thr = t.length >= 6 ? 2 : 1;
        if (best && bd > 0 && bd <= thr) { changed = true; return best; }
        return t;
      }).join(' ').replace(/\b([a-z0-9]+)( \1\b)+/g, '$1');
      return (changed && out !== qn) ? out : null;
    } catch (e) { return null; }
  };
})();
